import {
  dbui_v1_UpdateNotablesRequest,
  dbuiV1UpdateNotableMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';
import { defaultOptions } from '@/utils/query';

export const useCreateNotablesUpdate = () => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  return useMutation({
    mutationFn: (data: dbui_v1_UpdateNotablesRequest) =>
      dbuiV1UpdateNotableMutation({
        ...defaultOptions(),
      }).mutationFn!({
        body: data,
        path: { workspace },
        query: { warehouse: selectedWarehouse?.id || '' },
      }),
  });
};
